import { SendingTypes } from '@sigmasms/shared-types'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'PayloadText',

  mixins: [ proxy() ],

  props: {
    type: {
      type: String,
      default: undefined
    },

    disabled: {
      type: Boolean,
      default: false
    },

    tags: {
      type: Array,
      default: () => {
        return []
      }
    },

    customMenu: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  computed: {
    maxLength() {
      if (this.type === SendingTypes.voice) {
        return 3000
      }

      return null
    }
  },

  render
}
